export const rest = {
    url: process.env.REACT_APP_API_URL,
};
